import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=e5cc935a&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=e5cc935a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cc935a",
  null
  
)

export default component.exports